module.exports = __webpack_public_path__ + "img/04-B05.f7c9e730.png";